<script setup lang="ts">
import { refreshTokenIsValid, setAllCookies, tokenIsValid } from '@/services/utils';
import LoginRepository from '@/api/LoginRepository';
import AdminRepository from '@/api/AdminRepository';
import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { startSocket } from '@/services/socket';
import { useAdminStore } from '@/stores/admin';
import { storeToRefs } from 'pinia';

const { cookies } = useCookies();
const { admin } = storeToRefs(useAdminStore());

if (tokenIsValid()) {
  try {
    admin.value = await AdminRepository.getAdminProfile();
    await startSocket();
  } catch (e) {
    console.error(e);
  }
} else if (refreshTokenIsValid()) {
  try {
    const response = await LoginRepository.refresh(cookies.get(CookiesName.refreshToken));
    setAllCookies(response);
    admin.value = await AdminRepository.getAdminProfile();
    await startSocket();
  } catch (e) {
    console.error(e);
  }
}
</script>

<template>
  <slot></slot>
</template>

<style scoped lang="scss">

</style>